/* INNWELL v5 – Interaktion und Bewegung (Prototyp und Shopify, ohne Bibliotheken).
   Grundsätze: Inhalte sind ohne JS sichtbar und bedienbar; Bewegung nur mit .mo (keine reduzierte Bewegung);
   alles reagiert auf Tippen/Klicken/Tastatur, nichts hängt an Hover. */
(function () {
  'use strict';
  window.__innOk = true;
  var d = document, H = d.documentElement;
  var $ = function (s, c) { return (c || d).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || d).querySelectorAll(s)); };
  var RM = matchMedia('(prefers-reduced-motion: reduce)');
  var MO = function () { return H.classList.contains('iw-mo'); };   // gesetzt im Kopf-Skript: reduzierte Bewegung bzw. „Animationen aus“
  var DESK = matchMedia('(min-width: 900px)');
  var C = window.INNWELL || {};
  var raf = window.requestAnimationFrame || function (f) { return setTimeout(f, 16); };
  /* Scroll-Container: Horizon scrollt ab 990px nicht das Fenster, sondern .page-wrapper (html/body overflow: hidden).
     Alle scrollabhängigen Funktionen lesen die Position deshalb hierüber und hören auf Scroll-Ereignisse beider Quellen. */
  var scroller = null;
  function findScroller() { var pw = d.querySelector('.page-wrapper'); scroller = pw && /(auto|scroll)/.test(getComputedStyle(pw).overflowY) && pw.scrollHeight > pw.clientHeight + 1 ? pw : null; }
  findScroller(); window.addEventListener('resize', findScroller); window.addEventListener('load', findScroller);
  var scrollPos = function () { return scroller ? scroller.scrollTop : (window.scrollY || H.scrollTop || 0); };
  var onScroll = function (fn) {
    window.addEventListener('scroll', fn, { passive: true });
    d.addEventListener('scroll', function (e) { if (e.target !== d && e.target !== H) fn(e); }, { passive: true, capture: true });
  };

  /* ---------- Konfiguration: Ankündigung, Prelaunch, Bewertungen ---------- */
  /* Ankündigung: Pfeile + automatischer Wechsel (ca. 6 s, sanftes Überblenden, feste Höhe).
     Stopp nach manueller Bedienung; Pause bei Fokus, offenem Menü/Dialog, verborgenem Tab; aus bei reduzierter Bewegung / „Animationen aus“.
     Automatische Wechsel werden nicht vorgelesen (aria-live off), manuelle schon. */
  $$('[data-ann]').forEach(function (bar) {
    var msgs = $$('[data-ann-msg]', bar), i = 0, manual = false, track = $('.iw-ann-track', bar);
    if (msgs.length < 2) return;
    bar.classList.add('iw-ann-multi');
    if (track) track.setAttribute('aria-live', 'off');
    var show = function (k) {
      msgs[i].classList.remove('iw-is-on'); msgs[i].setAttribute('aria-hidden', 'true');
      i = (k + msgs.length) % msgs.length;
      msgs[i].classList.add('iw-is-on'); msgs[i].removeAttribute('aria-hidden');
    };
    $$('[data-ann-step]', bar).forEach(function (b) {
      b.hidden = false;
      b.addEventListener('click', function () { manual = true; if (track) track.setAttribute('aria-live', 'polite'); show(i + (+b.getAttribute('data-ann-step'))); });
    });
    setInterval(function () {
      if (manual || !MO() || d.hidden || bar.contains(d.activeElement) || d.body.classList.contains('iw-drawer-open') || H.classList.contains('iw-lock')) return;
      show(i + 1);
    }, 6000);
  });
  $$('[data-flag]').forEach(function (el) { if (C[el.getAttribute('data-flag')]) el.hidden = false; });
  if (C.prelaunch) {
    H.classList.add('iw-prelaunch');
    $$('[data-cta="primary"]').forEach(function (el) {
      if (el.tagName === 'A') { el.setAttribute('href', C.waitlistUrl || '#newsletter'); var t = el.querySelector('[data-label]'); if (t) t.textContent = 'Auf die Warteliste'; }
    });
  }

  /* ---------- Header: transparent über dem Hero, beim Runterscrollen ausblenden ---------- */
  var hdr = $('.iw-hdr'), hero = $('.iw-hero'), lastY = 0, ticking = false, MOBQ = matchMedia('(max-width: 899px)');
  // Im Shop ist der Section-Wrapper sticky; er wird komplett (inkl. Hintergrund) ausgeblendet
  var hdrBox = hdr ? (hdr.closest('.shopify-section') || hdr) : null;
  function onHdr() {
    ticking = false;
    if (!hdr) return;
    var y = scrollPos();
    // Etappe 11: Produktseite mobil – Header transparent über der Galerie, Logo/Icons je Slide dunkel oder hell
    var pg = hdr.classList.contains('iw-hdr-pdp') && MOBQ.matches ? $('.iw-pdp10 .iw-gtrack') : null, pov = false;
    if (pg) { pov = pg.getBoundingClientRect().bottom > hdr.getBoundingClientRect().bottom + 24; }
    var over = (!!hero && y < 8 && !hero.classList.contains('iw-tone-light-hdr')) || pov;
    hdr.classList.toggle('iw-is-over', over);
    var pgal = pg && pg.closest('.iw-gal');
    hdr.classList.toggle('iw-hdr-light', pov && !!pgal && pgal.getAttribute('data-tone') === 'dark');
    var hide = y > 520 && y > lastY + 2 && !hdr.contains(d.activeElement) && !d.body.classList.contains('iw-drawer-open');
    if (y < lastY - 2 || y < 520) hdrBox.classList.remove('iw-hdr-hidden'); else if (hide) hdrBox.classList.add('iw-hdr-hidden');
    lastY = y;
  }
  onScroll(function () { if (!ticking) { ticking = true; raf(onHdr); } });
  onHdr();
  if (MOBQ.addEventListener) MOBQ.addEventListener('change', onHdr); window.addEventListener('resize', function () { raf(onHdr); });

  /* ---------- Menü (Drawer) mit Fokusfalle ---------- */
  var dr = $('#iw-drawer'), openB = $('#iw-menu-open'), closeB = $('#iw-menu-close'), lastFocus = null;
  function setDrawer(open) {
    if (!dr) return;
    dr.classList.toggle('iw-open', open);
    dr.setAttribute('aria-hidden', open ? 'false' : 'true');
    if (open) dr.removeAttribute('inert'); else dr.setAttribute('inert', '');
    openB && openB.setAttribute('aria-expanded', open ? 'true' : 'false');
    d.body.classList.toggle('iw-drawer-open', open);
    d.body.style.overflow = open ? 'hidden' : '';
    H.classList.toggle('iw-lock', open);
    if (open) { lastFocus = d.activeElement; setTimeout(function () { closeB && closeB.focus(); }, 60); }
    else if (openB && openB.offsetParent !== null) openB.focus(); else if (lastFocus) lastFocus.focus();
  }
  if (dr) {
    $$('.iw-links a', dr).forEach(function (a, i) { a.style.setProperty('--i', i); a.addEventListener('click', function () { setDrawer(false); }); });
    openB && openB.addEventListener('click', function () { setDrawer(true); });
    closeB && closeB.addEventListener('click', function () { setDrawer(false); });
    $('.iw-scrim', dr) && $('.iw-scrim', dr).addEventListener('click', function () { setDrawer(false); });
    d.addEventListener('keydown', function (e) {
      if (!dr.classList.contains('iw-open')) return;
      if (e.key === 'Escape') { setDrawer(false); return; }
      if (e.key !== 'Tab') return;
      var f = $$('a, button', dr).filter(function (x) { return x.offsetParent !== null; });
      if (!f.length) return;
      if (e.shiftKey && d.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
      else if (!e.shiftKey && d.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
    });
  }

  /* ---------- Reveals ---------- */
  var revealEls = $$('[data-r]');
  if ('IntersectionObserver' in window && MO()) {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('iw-in'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -9% 0px', threshold: 0 });
    revealEls.forEach(function (el) { io.observe(el); });
    // Sicherheitsnetz: was schon im Bild ist oder beim schnellen Springen übersprungen wurde
    var sweep = function () { var vh = innerHeight; revealEls.forEach(function (el) { if (el.classList.contains('iw-in')) return; var r = el.getBoundingClientRect(); if (r.top < vh * 0.95 && r.bottom > -vh) el.classList.add('iw-in'); }); };
    onScroll(function () { raf(sweep); });
    setTimeout(sweep, 60);
  } else revealEls.forEach(function (el) { el.classList.add('iw-in'); });

  /* ---------- Parallax: [data-px] (Bild in Rahmen) und Hero-Tiefe [data-depth] ---------- */
  var pxEls = $$('[data-px]'), depthEls = $$('[data-depth]');
  function onPx() {
    if (!MO()) return;
    var vh = innerHeight;
    pxEls.forEach(function (el) {
      var r = el.parentNode.getBoundingClientRect(); if (r.bottom < -100 || r.top > vh + 100) return;
      var p = (r.top + r.height / 2 - vh / 2) / (vh / 2 + r.height / 2);
      el.style.transform = 'translate3d(0,' + (p * -(+el.getAttribute('data-px') || 6)).toFixed(2) + '%,0)';
    });
    if (hero && !hero.classList.contains('iw-has-media')) {
      var y = scrollPos(); if (y > vh * 1.2) return;
      depthEls.forEach(function (el) { el.style.transform = 'translate3d(0,' + (y * -(+el.getAttribute('data-depth'))).toFixed(1) + 'px,0)'; });
    }
  }
  if (pxEls.length || depthEls.length) { onScroll(function () { raf(onPx); }); window.addEventListener('resize', function () { raf(onPx); }); onPx(); }

  /* ---------- Hero-Video: nur abspielen, wenn sichtbar und Bewegung erlaubt; Pause-Knopf ---------- */
  $$('.iw-hero.iw-has-video').forEach(function (h) {
    var vids = $$('video', h), btn = $('.iw-vctl', h), paused = RM.matches;
    function vis(v) { return v.offsetParent !== null; }
    function sync() { vids.forEach(function (v) { if (vis(v) && !paused) { var p = v.play(); p && p.catch && p.catch(function () {}); } else v.pause(); }); if (btn) { btn.setAttribute('aria-label', paused ? 'Video abspielen' : 'Video pausieren'); btn.setAttribute('aria-pressed', paused ? 'true' : 'false'); $('.iw-i-pause', btn).style.display = paused ? 'none' : ''; $('.iw-i-play', btn).style.display = paused ? '' : 'none'; } }
    vids.forEach(function (v) { v.muted = true; v.playsInline = true; v.loop = true; });
    btn && btn.addEventListener('click', function () { paused = !paused; sync(); });
    if ('IntersectionObserver' in window) new IntersectionObserver(function (es) { es.forEach(function (e) { if (!e.isIntersecting) vids.forEach(function (v) { v.pause(); }); else sync(); }); }).observe(h);
    DESK.addEventListener && DESK.addEventListener('change', sync);
    sync();
  });

  /* ---------- Starter Kit: Desktop Sticky-Bühne, Mobile Wischkarten mit Tabs ---------- */
  $$('.iw-kit').forEach(function (kit) {
    var steps = $$('.iw-step', kit), objs = $$('.iw-kstage .iw-obj', kit), stage = $('.iw-kstage', kit), cur = -1;
    var tabs = $$('.iw-tabs a', kit), pill = $('.iw-tabs .iw-pill', kit), dots = $$('.iw-dots span', kit), track = $('.iw-track', kit);
    function setActive(i, fromScroll) {
      if (i === cur) return; var prev = cur; cur = i;
      steps.forEach(function (s, k) { s.classList.toggle('iw-on', k === i); });
      objs.forEach(function (o, k) { o.classList.remove('iw-out'); o.classList.toggle('iw-on', k === i); if (k === prev && k !== i) o.classList.add('iw-out'); });
      if (stage) { stage.style.setProperty('--prog', ((i + 1) / steps.length).toFixed(3)); stage.style.setProperty('--tint', i === 1 ? .55 : i === 2 ? .25 : 0); var b = $('.iw-count b', stage); if (b) b.textContent = '0' + (i + 1); }
      tabs.forEach(function (t, k) { t.setAttribute('aria-current', k === i ? 'true' : 'false'); });
      if (pill) pill.style.setProperty('--k', i);
      dots.forEach(function (t, k) { t.classList.toggle('iw-on', k === i); });
    }
    // Desktop: aktiver Schritt = der, dessen Mitte der Bildschirmmitte am nächsten ist
    function onDesk() {
      if (!DESK.matches) return;
      var line = innerHeight * 0.58, best = 0;
      steps.forEach(function (s, k) { var t = $('.iw-ktxt', s) || s; if (t.getBoundingClientRect().top <= line) best = k; });
      setActive(best);
    }
    // Mobile: aktive Karte aus der Scrollposition, dazu Parallax-Wert je Karte
    function onTrack() {
      if (DESK.matches || !track) return;
      var tr = track.getBoundingClientRect(), best = 0, bd = 1e9;
      steps.forEach(function (s, k) {
        var r = s.getBoundingClientRect(), off = (r.left - tr.left - parseFloat(getComputedStyle(track).paddingLeft)) / r.width;
        if (Math.abs(off) < bd) { bd = Math.abs(off); best = k; }
      });
      setActive(best, true);
    }
    tabs.forEach(function (t, k) {
      t.addEventListener('click', function (e) {
        if (DESK.matches || !track) return;
        e.preventDefault();
        track.scrollTo({ left: steps[k].offsetLeft - track.offsetLeft - parseFloat(getComputedStyle(track).paddingLeft), behavior: MO() ? 'smooth' : 'auto' });
      });
    });
    onScroll(function () { raf(onDesk); });
    track && track.addEventListener('scroll', function () { raf(onTrack); }, { passive: true });
    window.addEventListener('resize', function () { raf(function () { onDesk(); onTrack(); }); });
    setActive(0); onDesk(); onTrack();
  });

  /* ---------- Formel: Tabs (ARIA), weicher Wechsel ---------- */
  $$('.iw-formula').forEach(function (sec) {
    var tabs = $$('[role="tab"]', sec), panels = tabs.map(function (t) { return d.getElementById(t.getAttribute('aria-controls')); });
    function sel(i, focus) {
      tabs.forEach(function (t, k) { var on = k === i; t.setAttribute('aria-selected', on ? 'true' : 'false'); t.tabIndex = on ? 0 : -1; panels[k].hidden = !on; panels[k].classList.remove('iw-anim'); });
      void panels[i].offsetWidth; panels[i].classList.add('iw-anim');
      if (focus) tabs[i].focus();
      if (!DESK.matches) { var tl = tabs[i].parentNode; tl.scrollTo({ left: tabs[i].offsetLeft - tl.offsetLeft - 20, behavior: MO() ? 'smooth' : 'auto' }); }
    }
    tabs.forEach(function (t, k) {
      t.addEventListener('click', function () { sel(k); });
      t.addEventListener('keydown', function (e) {
        var n = { ArrowRight: 1, ArrowDown: 1, ArrowLeft: -1, ArrowUp: -1 }[e.key];
        if (n) { e.preventDefault(); sel((k + n + tabs.length) % tabs.length, true); }
        if (e.key === 'Home') { e.preventDefault(); sel(0, true); } if (e.key === 'End') { e.preventDefault(); sel(tabs.length - 1, true); }
      });
    });
    if (tabs.length) sel(0);
  });

  /* ---------- Akkordeons: weich öffnen/schließen (details bleibt ohne JS funktionsfähig) ---------- */
  $$('details.iw-acc').forEach(function (det) {
    var sum = $('summary', det), body = $('.iw-body', det), anim = null;
    if (!sum || !body || !body.animate) return;
    sum.addEventListener('click', function (e) {
      if (!MO()) return;
      e.preventDefault();
      if (anim) anim.cancel();
      if (!det.open) {
        det.open = true;
        var h = body.scrollHeight;
        anim = body.animate([{ height: '0px', opacity: 0 }, { height: h + 'px', opacity: 1 }], { duration: 460, easing: 'cubic-bezier(.16,1,.3,1)' });
      } else {
        var h2 = body.scrollHeight;
        anim = body.animate([{ height: h2 + 'px', opacity: 1 }, { height: '0px', opacity: 0 }], { duration: 320, easing: 'cubic-bezier(.65,0,.35,1)' });
        anim.onfinish = function () { det.open = false; anim = null; };
        return;
      }
      anim.onfinish = function () { anim = null; };
    });
  });

  /* ---------- Galerie (Produktseite) ---------- */
  $$('.iw-gal').forEach(function (g) {
    var tr = $('.iw-gtrack', g), sl = $$('.iw-slide', g), prog = $('.iw-gprog', g), cnt = $('.iw-gcount', g), prev = $('.iw-garr.iw-prev', g), next = $('.iw-garr.iw-next', g), cur = 0;
    if (!tr || !sl.length) return;
    if (prog) prog.style.setProperty('--w', (100 / sl.length).toFixed(2) + '%');
    function idx() { var tl = tr.getBoundingClientRect().left + parseFloat(getComputedStyle(tr).paddingLeft), best = 0, bd = 1e9; sl.forEach(function (s, k) { var c = Math.abs(s.getBoundingClientRect().left - tl); if (c < bd) { bd = c; best = k; } }); return best; }
    function upd() { cur = idx(); if (prog) prog.querySelector('i').style.setProperty('--x', cur); if (cnt) cnt.textContent = (cur + 1) + ' / ' + sl.length; if (prev) prev.disabled = cur === 0; if (next) next.disabled = cur === sl.length - 1; sl.forEach(function (s, k) { s.setAttribute('aria-hidden', k === cur ? 'false' : 'true'); }); thumbs.forEach(function (t, k) { t.setAttribute('aria-current', k === cur ? 'true' : 'false'); });
      var tone = sl[cur] && sl[cur].getAttribute('data-tone'); if (tone && g.getAttribute('data-tone') !== tone) { g.setAttribute('data-tone', tone); if (typeof onHdr === 'function') onHdr(); }
      var at = thumbs[cur]; if (at && at.parentNode && at.parentNode.scrollWidth > at.parentNode.clientWidth) { var p = at.parentNode, l = at.offsetLeft - p.offsetLeft; if (l < p.scrollLeft || l + at.offsetWidth > p.scrollLeft + p.clientWidth) p.scrollTo({ left: l - 8, behavior: 'auto' }); } }
    function go(k) { k = Math.max(0, Math.min(sl.length - 1, k)); tr.scrollTo({ left: sl[k].offsetLeft - tr.offsetLeft - parseFloat(getComputedStyle(tr).paddingLeft), behavior: MO() ? 'smooth' : 'auto' }); }
    var thumbs = $$('.iw-thumb', g);
    thumbs.forEach(function (t, k) { t.addEventListener('click', function () { go(k); }); });
    // Kaufoption → passendes Motiv (data-key), ohne Varianten-/Preislogik zu berühren
    g._goKey = function (key) { for (var k = 0; k < sl.length; k++) if (sl[k].getAttribute('data-key') === key) { go(k); return; } };
    prev && prev.addEventListener('click', function () { go(cur - 1); });
    next && next.addEventListener('click', function () { go(cur + 1); });
    tr.addEventListener('keydown', function (e) { if (e.key === 'ArrowRight') { e.preventDefault(); go(cur + 1); } if (e.key === 'ArrowLeft') { e.preventDefault(); go(cur - 1); } });
    tr.addEventListener('scroll', function () { raf(upd); }, { passive: true });
    upd();
  });

  /* ---------- Kaufmodul: Abo & Sparen / Einmaliger Kauf ----------
     Eine Radiogruppe (name="iw-plan") über beide Tabs: es ist immer genau ein Angebot gewählt, nie ein verstecktes Abo hinter „Einmaliger Kauf“.
     Vorschau (data-mode="preview"): keine Bestellung. Live: nur Angebote mit data-orderable="true" (Variante, Abo-Plan und Centpreis passen
     zu Shopify) gehen in den Warenkorb – immer Menge 1, selling_plan nur beim Abo. Bei Abo-Fehlern kein stiller Einmalkauf.
     Tracking: Shopify.analytics.publish('innwell:<event>') + CustomEvent 'innwell:track', nur bei Nutzeraktionen; add_to_cart erst nach Erfolg. */
  var pm = $('[data-pm]'), sticky = $('#iw-sticky'), toast = null, busy = false;
  var PM_MOCK = !!pm && C.mode === 'proto' && /[?&]pm=live\b/.test(location.search);
  var PM_LIVE = !!pm && (pm.getAttribute('data-mode') === 'live' || PM_MOCK);
  function showToast(html) {
    if (!toast) { toast = d.createElement('div'); toast.className = 'iw-toast'; toast.setAttribute('role', 'status'); (d.querySelector('.iw') || d.body).appendChild(toast); }
    toast.innerHTML = html;
    toast.classList.add('iw-show'); clearTimeout(toast._t); toast._t = setTimeout(function () { toast.classList.remove('iw-show'); }, 4200);
  }
  function setCount(n) { $$('[data-cart-count]').forEach(function (el) { el.textContent = n; el.hidden = !n; el.classList.remove('iw-bump'); void el.offsetWidth; el.classList.add('iw-bump'); }); $$('[data-cart-label]').forEach(function (el) { el.setAttribute('aria-label', 'Warenkorb, ' + n + ' Artikel'); }); }
  function setTxt(sel, v, anim) {
    $$(sel).forEach(function (el) {
      if (el.textContent === v) return;
      el.textContent = v;
      if (anim && MO()) { el.classList.remove('iw-swap'); void el.offsetWidth; el.classList.add('iw-swap'); }
    });
  }
  function pmSel() { return pm ? $('.iw-pm-radio:checked', pm) : null; }
  function pmData(r) {
    var g = function (k) { return r.getAttribute('data-' + k); }, sub = g('type') === 'sub';
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
    return { offer_id: g('offer-id'), purchase_type: sub ? 'subscription' : 'one_time', plan_months: +g('months'), quantity: +g('doses'), cart_quantity: 1,
      displayed_price: +g('price-cents') / 100, currency: cur, price_per_bottle: +g('per-cents') / 100, price_per_day: +g('pday-cents') / 100,
      starter_kit_included: g('kit') !== 'none', starter_kit_first_order_only: g('kit') === 'first', e_journal_included: g('ej') === 'true',
      free_shipping: g('ship') === 'true', subscription_interval: sub ? 'P' + g('months') + 'M' : null };
  }
  function track(name, r) {
    if (!r) return;
    var data = pmData(r);
    try { if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') Shopify.analytics.publish('innwell:' + name, data); } catch (e) {}
    var detail = Object.assign({ event: name }, data);
    (window.__iwEvents = window.__iwEvents || []).push(detail);
    try { window.dispatchEvent(new CustomEvent('innwell:track', { detail: detail })); } catch (e) {}
  }
  function pmErr(msg) { var e = pm && $('[data-pm-err]', pm); if (!e) return; e.textContent = msg || ''; e.hidden = !msg; }
  function pmApply(anim, user) {
    var r = pmSel(); if (!r) return;
    if (user) { try { sessionStorage.setItem('iw-pm-offer', r.value); } catch (e) {} }
    var g = function (k) { return r.getAttribute('data-' + k); }, type = g('type');
    $$('[data-pm-card]', pm).forEach(function (c) { c.classList.toggle('iw-on', c.contains(r)); });
    $$('[data-pm-tab]', pm).forEach(function (t) { var on = t.getAttribute('data-pm-tab') === type; t.setAttribute('aria-selected', on ? 'true' : 'false'); t.tabIndex = on ? 0 : -1; });
    $$('[data-pm-panel]', pm).forEach(function (p) { p.hidden = p.getAttribute('data-pm-panel') !== type; });
    setTxt('[data-sel-price]', g('price'), anim); setTxt('[data-sel-per]', g('per'), anim); setTxt('[data-sel-unit]', g('unit'), anim); setTxt('[data-sel-label]', g('label'), anim);
    setTxt('[data-sel-incl]', g('incl'), anim); setTxt('[data-pm-terms]', g('terms'), anim); setTxt('[data-sel-doses]', g('doses') + '×', anim);
    setTxt('[data-sel-ref]', g('ref') || '', false); $$('[data-sel-ref]').forEach(function (el) { el.hidden = !(+g('pct') > 0); });
    $$('[data-sel-acc]').forEach(function (el) { el.hidden = g('kit') === 'none'; });
    var stock = g('stock'), st = $('[data-pm-stock]', pm);
    if (st) { st.hidden = !(PM_LIVE && (stock === 'in' || stock === 'out')); st.textContent = stock === 'out' ? 'Ausverkauft' : (stock === 'in' ? 'Auf Lager' : ''); }
    var ok = PM_LIVE && (g('orderable') === 'true' || PM_MOCK) && stock !== 'out';
    $$('[data-pm-atc]').forEach(function (b) {
      if (C.prelaunch) { b.disabled = false; return; }
      b.disabled = busy || (PM_LIVE && !ok);
      var t = b.querySelector('[data-label]'); if (t) t.textContent = (PM_LIVE && stock === 'out') ? 'Ausverkauft' : (PM_LIVE && !ok ? 'Derzeit nicht bestellbar' : 'In den Warenkorb');
    });
    var prev = $('[data-pm-preview]', pm); if (prev) prev.hidden = PM_LIVE;
    if (user) {
      pmErr('');
      var lv = $('[data-pm-live]', pm); if (lv) lv.textContent = 'Gewählt: ' + g('label') + ', ' + g('price') + ' ' + g('unit') + '. ' + g('terms');
      var key = g('slide'), gal = $('.iw-gal'); if (key && gal && gal._goKey) gal._goKey(key);
    }
  }
  function pmPick(type) {
    var r = pmSel(), m = r ? r.getAttribute('data-months') : '3';
    var t = $('.iw-pm-radio[data-type="' + type + '"][data-months="' + m + '"]', pm) || $('.iw-pm-radio[data-type="' + type + '"]', pm);
    if (t) t.checked = true;
    return t;
  }
  function pmAdd() {
    if (busy || !pm) return;
    var r = pmSel(); if (!r) return;
    var g = function (k) { return r.getAttribute('data-' + k); }, sub = g('type') === 'sub';
    if (C.prelaunch) { location.href = C.waitlistUrl || '#newsletter'; return; }
    if (!PM_LIVE) { showToast('<span>' + g('label') + ' für ' + g('price') + ' ' + g('unit') + ' ist derzeit noch nicht bestellbar.</span>'); return; }
    var vid = g('variant'), plan = g('plan');
    if (!(g('orderable') === 'true' || PM_MOCK) || !vid) { pmErr('Dieses Angebot ist derzeit nicht bestellbar.'); return; }
    if (sub && !plan) { pmErr('Für dieses Abo ist kein Abo-Plan hinterlegt. Bitte wähle ein anderes Angebot.'); return; }
    var qty = +g('qty') || 1, expect = +g('expect-cents'), prevQty = {}, added = null;
    // Nur diese Aktion zurücknehmen: Position auf ihre Menge vor dem Hinzufügen zurücksetzen (0 = neu angelegt)
    var undo = function (key) { return fetch(cartUrl + '/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: key, quantity: prevQty[key] || 0 }) }).catch(function () {}); };
    var item = { id: PM_MOCK ? vid : +vid, quantity: qty };
    if (sub) item.selling_plan = PM_MOCK ? plan : +plan;
    busy = true; pmErr('');
    var btns = $$('[data-pm-atc]'); btns.forEach(function (b) { b.disabled = true; b.setAttribute('aria-busy', 'true'); });
    var base = PM_MOCK ? '/cart/add' : ((C.routes && C.routes.cartAdd) || '/cart/add');
    var cartUrl = PM_MOCK ? '/cart' : ((C.routes && C.routes.cart) || '/cart');
    // Vorhandene Warenkorbartikel bleiben unangetastet. Liegt BELLY RITUAL schon im Warenkorb, würde Shopify die Mengen
    // zusammenführen (andere Paketgröße/Preisstufe) – dann nicht hinzufügen, sondern auf den Warenkorb verweisen.
    fetch(cartUrl + '.js', { headers: { 'Accept': 'application/json' } }).then(function (x) { return x.json(); }).catch(function () { return { items: [] }; })
      .then(function (cart) {
        prevQty = {}; (cart.items || []).forEach(function (l) { prevQty[l.key] = l.quantity; });
        var dup = (cart.items || []).some(function (l) { return String(l.variant_id) === String(item.id); });
        if (dup) throw { description: 'BELLY RITUAL liegt bereits im Warenkorb. Bitte passe dein Paket dort an oder entferne es, bevor du ein anderes wählst.', cartLink: true };
        return fetch(base + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [item] }) });
      })
      .then(function (res) { return res.json().catch(function () { return {}; }).then(function (j) { if (!res.ok) throw j; return j; }); })
      .then(function (j) {
        var line = j && j.items && j.items[0]; added = line && line.key;
        if (sub && !(line && line.selling_plan_allocation && String(line.selling_plan_allocation.selling_plan.id) === String(item.selling_plan) && line.quantity === qty)) {
          // Sicherheitsnetz: ohne bestätigten Abo-Plan keine Einmalkauf-Position im Warenkorb lassen
          var rm = line && line.key ? undo(line.key) : Promise.resolve();
          return rm.then(function () { throw { description: 'Das Abo konnte nicht angelegt werden. Es wurde nichts in den Warenkorb gelegt.' }; });
        }
        return fetch(cartUrl + '.js', { headers: { 'Accept': 'application/json' } }).then(function (x) { return x.json(); }).catch(function () { return null; });
      })
      .then(function (cart) {
        // Endpreis nach Shopify-Rabatten prüfen (Anzeige allein ist kein Nachweis)
        var ln = cart && (cart.items || []).filter(function (l) { return l.key === added; })[0];
        if (ln && typeof ln.final_line_price === 'number' && ln.final_line_price !== expect) {
          var shown = (ln.final_line_price / 100).toFixed(2).replace('.', ',') + ' €';
          return undo(added).then(function () { throw { description: 'Shopify berechnet für dieses Paket derzeit ' + shown + ' statt ' + g('price') + '. Es wurde nichts hinzugefügt.' }; });
        }
        if (cart && cart.items && !ln) throw { description: 'Die Warenkorb-Position konnte nicht bestätigt werden. Bitte prüfe deinen Warenkorb.', cartLink: true };
        return cart;
      })
      .then(function (cart) {
        if (cart && typeof cart.item_count === 'number') setCount(cart.item_count);
        // Etappe 14.16: Warenkorb-Drawer öffnen; ohne Drawer (oder wenn das Neuladen scheitert) wie bisher der Hinweis oben
        var note = function () { showToast('<span>' + g('label') + ' liegt im Warenkorb.</span><a href="' + cartUrl + '">Zum Warenkorb</a>'); };
        if (cd && !PM_MOCK) cdRefresh().then(function () { cdOpen(true); }, note); else note();
        track('add_to_cart', r);
      })
      .catch(function (e) {
        pmErr((e && (e.description || e.message)) || 'Das hat leider nicht geklappt. Bitte versuche es erneut.');
        if (e && e.cartLink) { var el = $('[data-pm-err]', pm); if (el) { var a = d.createElement('a'); a.href = cartUrl; a.textContent = ' Zum Warenkorb'; el.appendChild(a); } }
      })
      .then(function () { busy = false; btns.forEach(function (b) { b.removeAttribute('aria-busy'); }); pmApply(false, false); });
  }
  if (pm) {
    pm.classList.add('iw-pm-js');
    try { var saved = sessionStorage.getItem('iw-pm-offer'), sr = saved && $('.iw-pm-radio[value="' + saved + '"]', pm); if (sr) sr.checked = true; } catch (e) {}
    if (!pmSel()) pmPick('sub');
    pmApply(false, false);
    $$('.iw-pm-radio', pm).forEach(function (r) {
      r.addEventListener('change', function () {
        pmApply(true, true);
        track('purchase_plan_selected', r);
        track(r.getAttribute('data-type') === 'sub' ? 'subscription_selected' : 'one_time_selected', r);
      });
    });
    var tabs = $$('[data-pm-tab]', pm);
    var toTab = function (type, focus) {
      var r0 = pmSel(); if (r0 && r0.getAttribute('data-type') === type) { if (focus) $('[data-pm-tab="' + type + '"]', pm).focus(); return; }
      var r = pmPick(type); pmApply(true, true);
      if (focus) $('[data-pm-tab="' + type + '"]', pm).focus();
      track('purchase_type_changed', r); track('purchase_plan_selected', r); track(type === 'sub' ? 'subscription_selected' : 'one_time_selected', r);
    };
    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { toTab(t.getAttribute('data-pm-tab'), false); });
      t.addEventListener('keydown', function (e) {
        var k = e.key, j = null;
        if (k === 'ArrowRight' || k === 'ArrowLeft') j = (i + (k === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
        if (k === 'Home') j = 0; if (k === 'End') j = tabs.length - 1;
        if (j !== null) { e.preventDefault(); toTab(tabs[j].getAttribute('data-pm-tab'), true); }
      });
    });
    $$('[data-pm-atc]').forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); pmAdd(); }); });
  }
  /* ---------- Warenkorb-Drawer (Etappe 14.16) ----------
     Markup + Preise kommen aus der Section innwell-cart-drawer (Liquid); hier nur Öffnen/Schließen und Neuladen über die Section Rendering API.
     Entfernen: /cart/change.js (Menge 0). Rabattcode: /cart/update.js {discount} wie im Horizon-Warenkorb. Keine Mengenänderung, keine Plan-Änderung.
     Das Warenkorb-Symbol im Header öffnet den Drawer; der Link auf /cart bleibt als Rückfall ohne JS. */
  var cd = $('#iw-cart'), cdLast = null, CD_ID = 'innwell-cart-drawer';
  var shopRoot = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  function cdJSON(url, body) {
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) })
      .then(function (res) { return res.json().catch(function () { return {}; }).then(function (j) { if (!res.ok) throw j; return j; }); });
  }
  function cdPaint(html) {
    if (!cd || !html) return;
    var t = d.createElement('div'); t.innerHTML = html;
    var np = $('.iw-cd-panel', t), op = $('.iw-cd-panel', cd), nr = $('#iw-cart', t);
    if (!np || !op) return;
    var openCode = !!$('.iw-cd-code[open]', cd), focusSel = d.activeElement && cd.contains(d.activeElement) && d.activeElement.id ? '#' + d.activeElement.id : null;
    var ob = $('.iw-cd-bar i', cd), oldP = ob ? ob.style.getPropertyValue('--p') : '';
    op.innerHTML = np.innerHTML;
    // Versand-Fortschritt vom alten zum neuen Stand laufen lassen statt springen
    var nb = $('.iw-cd-bar i', cd), newP = nb ? nb.style.getPropertyValue('--p') : '';
    if (nb && oldP && oldP !== newP) { nb.style.setProperty('--p', oldP); void nb.offsetWidth; setTimeout(function () { nb.style.setProperty('--p', newP); }, 30); }
    if (openCode && $('.iw-cd-code', cd)) $('.iw-cd-code', cd).open = true;
    if (nr) setCount(+nr.getAttribute('data-count') || 0);
    var f = focusSel && $(focusSel, cd); if (f) f.focus(); else if (cd.classList.contains('iw-open')) { var c = $('[data-cd-close].iw-ibtn', cd); c && c.focus(); }
  }
  function cdRefresh() {
    return fetch(shopRoot + '?sections=' + CD_ID, { headers: { 'Accept': 'application/json' } })
      .then(function (r) { if (!r.ok) throw r; return r.json(); })
      .then(function (j) { if (!j || !j[CD_ID]) throw j; cdPaint(j[CD_ID]); });
  }
  function cdOpen(open) {
    if (!cd) return;
    if (open && dr && dr.classList.contains('iw-open')) setDrawer(false);
    cd.classList.toggle('iw-open', open);
    cd.setAttribute('aria-hidden', open ? 'false' : 'true');
    if (open) cd.removeAttribute('inert'); else cd.setAttribute('inert', '');
    d.body.classList.toggle('iw-drawer-open', open);
    d.body.style.overflow = open ? 'hidden' : '';
    H.classList.toggle('iw-lock', open);
    H.classList.toggle('iw-cart-open', open);
    if (open) { cdLast = d.activeElement; setTimeout(function () { var c = $('[data-cd-close].iw-ibtn', cd); c && c.focus(); }, 60); }
    else if (cdLast && cdLast.focus) cdLast.focus();
  }
  function cdBusy(on) { cd.classList.toggle('iw-busy', on); }
  function cdCodes() { return $$('[data-cd-code-rm]', cd).map(function (b) { return b.getAttribute('data-cd-code-rm'); }); }
  function cdCodeErr(msg) { var e = $('[data-cd-code-err]', cd); if (e) { e.textContent = msg || ''; e.hidden = !msg; } }
  if (cd) {
    var onCartPage = /\/cart\/?$/.test(location.pathname);
    $$('[data-cart-label]').forEach(function (a) {
      if (onCartPage) return;
      a.setAttribute('aria-haspopup', 'dialog'); a.setAttribute('aria-controls', 'iw-cart');
      a.addEventListener('click', function (e) { if (e.metaKey || e.ctrlKey || e.shiftKey) return; e.preventDefault(); cdOpen(true); });
    });
    cd.addEventListener('click', function (e) {
      var t = e.target.closest ? e.target : null; if (!t) return;
      if (t.closest('[data-cd-close]')) { cdOpen(false); return; }
      var rm = t.closest('[data-cd-remove]');
      if (rm) {
        cdBusy(true);
        cdJSON(shopRoot + 'cart/change.js', { id: rm.getAttribute('data-cd-remove'), quantity: 0, sections: CD_ID })
          .then(function (j) { if (j.sections && j.sections[CD_ID]) cdPaint(j.sections[CD_ID]); else return cdRefresh(); })
          .catch(function () { return cdRefresh(); })
          .then(function () { cdBusy(false); });
        return;
      }
      var cr = t.closest('[data-cd-code-rm]');
      if (cr) {
        var keep = cdCodes().filter(function (c) { return c !== cr.getAttribute('data-cd-code-rm'); });
        cdBusy(true);
        cdJSON(shopRoot + 'cart/update.js', { discount: keep.join(','), sections: CD_ID })
          .then(function (j) { if (j.sections && j.sections[CD_ID]) cdPaint(j.sections[CD_ID]); else return cdRefresh(); })
          .catch(function () { return cdRefresh(); })
          .then(function () { cdBusy(false); });
      }
    });
    cd.addEventListener('submit', function (e) {
      var f = e.target.closest('[data-cd-code]'); if (!f) return;
      e.preventDefault();
      var inp = $('input', f), code = (inp.value || '').trim(), btn = $('button', f);
      if (!code) { cdCodeErr('Bitte gib einen Rabattcode ein.'); inp.focus(); return; }
      var had = cdCodes();
      if (had.some(function (c) { return c.toLowerCase() === code.toLowerCase(); })) { cdCodeErr('Dieser Rabattcode ist bereits eingelöst.'); return; }
      cdCodeErr(''); btn.setAttribute('aria-busy', 'true'); cdBusy(true);
      cdJSON(shopRoot + 'cart/update.js', { discount: had.concat([code]).join(','), sections: CD_ID })
        .then(function (j) {
          var hit = (j.discount_codes || []).filter(function (c) { return String(c.code).toLowerCase() === code.toLowerCase(); })[0];
          if (hit && hit.applicable) return cdPaint(j.sections && j.sections[CD_ID]);
          // Ungültig oder nicht anwendbar: Code wieder entfernen, Hinweis zeigen
          return cdJSON(shopRoot + 'cart/update.js', { discount: had.join(','), sections: CD_ID })
            .then(function (k) { cdPaint(k.sections && k.sections[CD_ID]); }, function () { return cdRefresh(); })
            .then(function () { cdCodeErr('Dieser Rabattcode ist nicht gültig oder gilt nicht für deinen Warenkorb.'); var i2 = $('#iw-cd-code-in', cd); if (i2) { i2.value = code; i2.focus(); } });
        })
        .catch(function () { cdCodeErr('Das hat leider nicht geklappt. Bitte versuche es erneut.'); })
        .then(function () { cdBusy(false); var b2 = $('[data-cd-code] button', cd); b2 && b2.removeAttribute('aria-busy'); });
    });
    d.addEventListener('keydown', function (e) {
      if (!cd.classList.contains('iw-open')) return;
      if (e.key === 'Escape') { cdOpen(false); return; }
      if (e.key !== 'Tab') return;
      var f = $$('a, button, input, summary', cd).filter(function (x) { return x.offsetParent !== null && !x.disabled; });
      if (!f.length) return;
      if (e.shiftKey && d.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
      else if (!e.shiftKey && d.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
    });
    // Zurück-Navigation aus dem Checkout (bfcache): Warenkorb kann sich geändert haben
    window.addEventListener('pageshow', function (e) { if (e.persisted) cdRefresh().catch(function () {}); });
  }

  /* Mobiler Kaufbalken: nur wenn weder Hauptbutton noch Angebotskarten im Bild sind; weg am Seitenende */
  if (sticky && pm) {
    var mainBtn = $('.iw-buy .iw-atc [data-atc]'), offersBox = $('.iw-pm-tabs', pm), cardsBox = pm, ends = $$('.iw-band, .iw-foot'), stOn = null;
    var vis = function (el, vh) { if (!el) return false; var r = el.getBoundingClientRect(); return r.top < vh - 72 && r.bottom > 0; };
    var st = function () {
      var vh = innerHeight, r0 = mainBtn ? mainBtn.getBoundingClientRect() : null;
      var above = r0 && r0.bottom < 0, below = r0 && r0.top > vh - 72 && scrollPos() > 80;
      var endVis = ends.some(function (el) { var r = el.getBoundingClientRect(); return r.top < vh - 40 && r.bottom > 0; });
      var on = !!(above || below) && !endVis && !vis(cardsBox, vh) && !DESK.matches;
      if (on === stOn) return; stOn = on;
      sticky.classList.toggle('iw-show', on); sticky.setAttribute('aria-hidden', on ? 'false' : 'true');
      if (on) sticky.removeAttribute('inert'); else sticky.setAttribute('inert', '');
      d.body.classList.toggle('iw-has-sticky', on);
    };
    onScroll(function () { raf(st); });
    window.addEventListener('resize', function () { raf(st); });
    st();
  }

  /* ---------- Produkt-Erklärung: Dose → Tagesportion → schematische Kapsel → Inhaltsstoffgruppen ----------
     Nur mit Bewegung interaktiv; sonst bleibt die statische Fassung (alle Schritte untereinander).
     Kein Scroll-Zwang: Schritte über Tasten, Fortschritt, Pfeiltasten oder Wischen. Einmaliger Auto-Einstieg (Dose → Kapseln → erste Gruppe, < 5 s). */
  $$('.iw-xp').forEach(function (x) {
    if (!MO()) return;
    var steps = $$('.iw-xp-step', x), segs = $$('.iw-xp-seg', x), gs = $$('.iw-xp-g', x), n = steps.length, NI = n - gs.length;
    var prev = $('.iw-xp-prev', x), next = $('.iw-xp-next', x), cnt = $('.iw-xp-count b', x), panel = $('.iw-xp-panel', x), cur = -1, timers = [], user = false;
    x.classList.add('iw-xp-on');
    function set(k, byUser) {
      k = Math.max(0, Math.min(n - 1, k)); if (k === cur) return; cur = k;
      if (byUser) { user = true; timers.forEach(clearTimeout); timers = []; panel.setAttribute('aria-live', 'polite'); }
      x.setAttribute('data-step', k);
      x.classList.toggle('iw-xp-s1', k === 1); x.classList.toggle('iw-xp-s2', k >= 2);
      steps.forEach(function (s, i) { var on = i === k; s.classList.toggle('iw-on', on); s.setAttribute('aria-hidden', on ? 'false' : 'true'); if (on) s.removeAttribute('inert'); else s.setAttribute('inert', ''); });
      gs.forEach(function (g, i) { g.classList.toggle('iw-on', i === k - NI); });
      segs.forEach(function (b, i) { if (i === k) b.setAttribute('aria-current', 'step'); else b.removeAttribute('aria-current'); });
      prev.disabled = k === 0; next.disabled = k === n - 1; if (cnt) cnt.textContent = k + 1;
    }
    set(0);
    prev.addEventListener('click', function () { set(cur - 1, true); });
    next.addEventListener('click', function () { set(cur + 1, true); });
    segs.forEach(function (b, i) { b.addEventListener('click', function () { set(i, true); }); });
    x.addEventListener('keydown', function (e) {
      if (!x.querySelector('.iw-xp-nav').contains(d.activeElement)) return;
      if (e.key === 'ArrowRight') { e.preventDefault(); set(cur + 1, true); } else if (e.key === 'ArrowLeft') { e.preventDefault(); set(cur - 1, true); }
    });
    var sx = null, sy = 0, area = $('.iw-xp-grid', x);
    area.addEventListener('pointerdown', function (e) { if (e.pointerType === 'mouse') return; sx = e.clientX; sy = e.clientY; }, { passive: true });
    area.addEventListener('pointerup', function (e) { if (sx === null) return; var dx = e.clientX - sx, dy = e.clientY - sy; sx = null; if (Math.abs(dx) > 44 && Math.abs(dx) > Math.abs(dy) * 1.4) set(cur + (dx < 0 ? 1 : -1), true); }, { passive: true });
    area.addEventListener('pointercancel', function () { sx = null; });
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          if (!e.isIntersecting || user) return; io.disconnect();
          timers.push(setTimeout(function () { if (!user) set(1); }, 1300));
          timers.push(setTimeout(function () { if (!user) set(2); }, 3300));
        });
      }, { threshold: 0.45 });
      io.observe($('.iw-xp-stage', x));
    }
  });

  /* ---------- Faktenstreifen: Tempo nach Länge (ca. 30 px/s), Pause-Knopf ---------- */
  $$('.iw-ticker').forEach(function (t) {
    var b = $('.iw-tk-btn, .iw-tk-mini', t), list = $('.iw-tk-list', t), lists = $$('.iw-tk-list', t), view = $('.iw-tk-view', t);
    var base = list ? list.innerHTML : '', extra = base.replace(/<li>/g, '<li aria-hidden="true">');
    var dur = function () { if (list) t.style.setProperty('--tk-dur', Math.max(30, Math.round(list.scrollWidth / 30)) + 's'); };
    /* Etappe 8.5: Begriffe so oft wiederholen, dass jede Liste mindestens so breit ist wie die Leiste (sonst Lücke auf breiten Bildschirmen) */
    var fill = function () {
      if (!list || !view || !MO()) { dur(); return; }
      lists.forEach(function (l, i) { l.innerHTML = i ? extra : base; });
      for (var n = 0; n < 16 && list.scrollWidth < view.clientWidth + 40; n++) lists.forEach(function (l) { l.insertAdjacentHTML('beforeend', extra); });
      dur();
    };
    var lastW = 0;
    fill(); window.addEventListener('resize', function () { if (Math.abs(innerWidth - lastW) > 40) { lastW = innerWidth; raf(fill); } });
    lastW = innerWidth;
    b && b.addEventListener('click', function () {
      var p = !t.classList.contains('iw-paused');
      t.classList.toggle('iw-paused', p);
      b.setAttribute('aria-pressed', p ? 'true' : 'false');
      b.setAttribute('aria-label', p ? 'Laufband abspielen' : 'Laufband anhalten');
    });
  });

  /* ---------- Lieferumfang: Liste hebt Markierung im Bild hervor ---------- */
  $$('.iw-incl').forEach(function (s) {
    var items = $$('.iw-items li', s), marks = $$('.iw-mark', s);
    items.forEach(function (li, k) {
      var on = function () { marks.forEach(function (m, j) { m.classList.toggle('iw-hi', j === k); }); };
      li.addEventListener('mouseenter', on); li.addEventListener('focusin', on); li.addEventListener('click', on);
    });
  });

  /* ---------- Newsletter im Prototyp (Shopify sendet echt ab) ---------- */
  $$('form[data-proto-form]').forEach(function (f) {
    f.addEventListener('submit', function (e) { e.preventDefault(); var m = $('.iw-msg', f); var inp = $('input[type="email"]', f); if (inp && !inp.checkValidity()) { m.textContent = 'Bitte gib eine gültige E-Mail-Adresse ein.'; inp.focus(); return; } m.textContent = 'Danke! (Prototyp: es wurde nichts gesendet.)'; });
  });
  /* ---------- Newsletter -> Klaviyo (Client Subscriptions API, Double-Opt-in der Liste) ---------- */
  $$('form').forEach(function (f) {
    var kl = $('[data-kl]', f); if (!kl) return;
    var key = kl.getAttribute('data-kl-key'), list = kl.getAttribute('data-kl-list');
    if (!key || !list) return;   // ohne Schlüssel/Liste: normaler Shopify-Versand
    f.addEventListener('submit', function (e) {
      e.preventDefault();
      var m = $('.iw-msg', f), inp = $('input[type="email"]', f), b = $('button[type="submit"]', f);
      if (!inp || !inp.value.trim() || !inp.checkValidity()) { m.textContent = 'Bitte gib eine gültige E-Mail-Adresse ein.'; if (inp) inp.focus(); return; }
      if (b) b.disabled = true; m.textContent = 'Einen Moment …';
      fetch('https://a.klaviyo.com/client/subscriptions?company_id=' + encodeURIComponent(key), {
        method: 'POST', headers: { 'Content-Type': 'application/vnd.api+json', revision: '2024-10-15' },
        body: JSON.stringify({ data: { type: 'subscription', attributes: { custom_source: 'INNWELL Website Newsletter', profile: { data: { type: 'profile', attributes: { email: inp.value.trim(), subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } } } } } }, relationships: { list: { data: { type: 'list', id: list } } } } })
      }).then(function (r) {
        if (r.status === 202 || r.ok) { m.textContent = 'Fast geschafft! Bitte bestätige deine Anmeldung über den Link in der E-Mail, die wir dir gerade geschickt haben.'; inp.value = ''; }
        else { m.textContent = 'Das hat leider nicht geklappt. Bitte versuche es später noch einmal.'; }
      }).catch(function () { m.textContent = 'Das hat leider nicht geklappt. Bitte prüfe deine Verbindung und versuche es noch einmal.'; })
        .then(function () { if (b) b.disabled = false; });
    });
  });
  /* ================================================================== v7: Slider, Dialoge, Abschnittsnavigation, Footer */
  /* ---------- Slider: Scroll-Snap, Pfeile, Punkte, Wischen (nativ), kein Autoplay ---------- */
  $$('[data-slider]').forEach(function (sl) {
    var tr = $('.iw-sl-track', sl), items = $$('.iw-sl-item', sl), ctl = $('.iw-sl-ctl', sl), dots = $('[data-sl-dots]', sl);
    var prev = $('[data-sl-prev]', sl), next = $('[data-sl-next]', sl), cur = -1;
    if (!tr || items.length < 2) return;
    var perView = function () { return Math.max(1, Math.round(tr.clientWidth / (items[0].getBoundingClientRect().width || 1))); };
    var pages = function () { return Math.max(1, items.length - perView() + 1); };
    var go = function (i) { i = Math.max(0, Math.min(pages() - 1, i)); tr.scrollTo({ left: items[i].offsetLeft - items[0].offsetLeft, behavior: RM.matches ? 'auto' : 'smooth' }); };
    var build = function () {
      dots.innerHTML = '';
      for (var i = 0; i < pages(); i++) { var b = d.createElement('button'); b.type = 'button'; b.className = 'iw-sl-dot'; b.setAttribute('aria-label', (sl.getAttribute('data-sl-unit') || 'Karte') + ' ' + (i + 1) + ' von ' + pages()); (function (k) { b.addEventListener('click', function () { go(k); }); })(i); dots.appendChild(b); }
      ctl.hidden = pages() < 2; cur = -1;
      // Pfeile außerhalb der Steuerleiste (Bild-Slider): nur zeigen, wenn es etwas zu blättern gibt und sie nicht abgeschaltet sind
      if (!ctl.contains(prev)) prev.hidden = next.hidden = pages() < 2 || sl.hasAttribute('data-sl-noarrows');
      upd();
    };
    var upd = function () {
      var x = tr.scrollLeft, best = 0, bd = 1e9;
      items.forEach(function (it, i) { var dd = Math.abs(it.offsetLeft - items[0].offsetLeft - x); if (dd < bd) { bd = dd; best = i; } });
      if (x + tr.clientWidth >= tr.scrollWidth - 4) best = pages() - 1;
      best = Math.min(best, pages() - 1);
      if (best === cur) return; cur = best;
      $$('.iw-sl-dot', dots).forEach(function (b, i) { b.setAttribute('aria-current', i === cur ? 'true' : 'false'); });
      var fo = d.activeElement;
      prev.disabled = cur === 0; next.disabled = cur >= pages() - 1;
      // Bild-Slider: ausgeblendeter Pfeil (Anfang/Ende) gibt den Tastaturfokus an den anderen Pfeil weiter
      if (!ctl.contains(prev)) { if (fo === next && next.disabled) prev.focus({ preventScroll: true }); else if (fo === prev && prev.disabled) next.focus({ preventScroll: true }); }
    };
    prev.addEventListener('click', function () { go(cur - 1); });
    next.addEventListener('click', function () { go(cur + 1); });
    tr.addEventListener('scroll', function () { raf(upd); }, { passive: true });
    tr.addEventListener('keydown', function (e) { if (e.key === 'ArrowRight') { e.preventDefault(); go(cur + 1); } if (e.key === 'ArrowLeft') { e.preventDefault(); go(cur - 1); } });
    var rw = 0; window.addEventListener('resize', function () { if (innerWidth !== rw) { rw = innerWidth; build(); } });
    rw = innerWidth; build();
  });

  /* ---------- Dialoge: eigener Scrollbereich, Escape, Fokus hinein und zurück, Hintergrund gesperrt ---------- */
  var openDlg = null, opener = null;
  var lock = function (on) { H.classList.toggle('iw-lock', on); };
  var closeDlg = function (dlg) {
    if (!dlg || !dlg.open) return;
    dlg.classList.remove('iw-open');
    var done = function () { if (dlg.open) dlg.close(); lock(false); openDlg = null; if (opener && opener.focus) opener.focus(); };
    if (RM.matches) done(); else setTimeout(done, 280);
  };
  $$('dialog.iw-dlg').forEach(function (dlg) {
    if (dlg.parentNode !== d.body) d.body.appendChild(dlg.closest('.iw') === dlg ? dlg : wrapIw(dlg));
    dlg.addEventListener('cancel', function (e) { e.preventDefault(); closeDlg(dlg); });
    dlg.addEventListener('click', function (e) { if (e.target === dlg) closeDlg(dlg); });
    $$('[data-dialog-close]', dlg).forEach(function (b) { b.addEventListener('click', function () { closeDlg(dlg); }); });
  });
  function wrapIw(dlg) { var w = d.createElement('div'); w.className = 'iw iw-dlg-host'; w.appendChild(dlg); return w; }
  d.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-dialog-open]'); if (!t) return;
    var dlg = d.getElementById(t.getAttribute('data-dialog-open')); if (!dlg) return;
    e.preventDefault(); opener = t;
    if (openDlg && openDlg !== dlg) { openDlg.classList.remove('iw-open'); openDlg.close(); }
    if (typeof dlg.showModal === 'function') dlg.showModal(); else dlg.setAttribute('open', '');
    openDlg = dlg; lock(true);
    var body = $('.iw-dlg-body', dlg); if (body) body.scrollTop = 0;
    var hd = $('.iw-dlg-h', dlg); if (hd) { hd.setAttribute('tabindex', '-1'); hd.focus(); }
    raf(function () { raf(function () { dlg.classList.add('iw-open'); }); });
  });

  /* ---------- Abschnittsnavigation: unter dem Header fixiert, solange der gemeinsame Bereich sichtbar ist; aktiver Abschnitt markiert ---------- */
  var snSlot = $('[data-snav-slot]'), sn = $('[data-snav]'), snEnd = $('[data-snav-end]');
  if (snSlot && sn) {
    var snLinks = $$('[data-snav-link]', sn), snTargets = snLinks.map(function (a) { return d.getElementById(a.getAttribute('href').slice(1)); });
    var snActive = null;
    var snUpd = function () {
      var hb = hdrBox || hdr, hdrVis = hb && !hb.classList.contains('iw-hdr-hidden') ? (hdr ? hdr.getBoundingClientRect().bottom : 0) : 0;
      var top = Math.max(0, hdrVis), st = snSlot.getBoundingClientRect().top, eb = snEnd ? snEnd.getBoundingClientRect().bottom : 1e9;
      var fix = st <= top && eb > top + sn.offsetHeight;
      sn.classList.toggle('iw-fixed', fix); sn.style.setProperty('--snav-top', top + 'px');
      var line = top + sn.offsetHeight + 120, act = null;
      snTargets.forEach(function (t, i) { if (t && t.getBoundingClientRect().top <= line) act = i; });
      if (act !== snActive) {
        snActive = act;
        snLinks.forEach(function (a, i) { if (i === act) { a.setAttribute('aria-current', 'true'); var row = a.parentNode; row.scrollTo({ left: a.offsetLeft - (row.clientWidth - a.offsetWidth) / 2, behavior: RM.matches ? 'auto' : 'smooth' }); } else a.removeAttribute('aria-current'); });
      }
    };
    onScroll(function () { raf(snUpd); }); window.addEventListener('resize', snUpd); snUpd();
    snLinks.forEach(function (a, i) { a.addEventListener('click', function (e) {
      var t = snTargets[i]; if (!t) return; e.preventDefault();
      var cur = scrollPos(), rt = t.getBoundingClientRect().top, down = rt > 0;
      var off = sn.offsetHeight + 12 + (down ? 0 : (hdr ? hdr.offsetHeight : 0));   // nach unten blendet der Header aus, nach oben ein
      var y = Math.max(0, cur + rt - off), opt = { top: y, behavior: RM.matches ? 'auto' : 'smooth' };
      if (scroller) scroller.scrollTo(opt); else window.scrollTo(opt);
      if (history.replaceState) history.replaceState(null, '', '#' + t.id);
    }); });
  }

  /* ---------- Footer: mobil Akkordeons, Desktop Spalten (immer offen) ---------- */
  var fgs = $$('[data-fg]');
  var fgSet = function () { fgs.forEach(function (g) { if (DESK.matches) g.setAttribute('open', ''); else g.removeAttribute('open'); }); };
  if (fgs.length) { fgSet(); DESK.addEventListener ? DESK.addEventListener('change', fgSet) : DESK.addListener(fgSet); fgs.forEach(function (g) { $('summary', g).addEventListener('click', function (e) { if (DESK.matches) e.preventDefault(); }); }); }
  /* ---------- Rezeptur-Kapsel: einmal beim Eintritt (über Reveal), optional wiederholen ---------- */
  /* ---------- Story-Seite (Etappe 9.1): Karten im Einstieg mit Pfeilen umschalten ---------- */
  $$('[data-stc]').forEach(function (w) {
    var cs = $$('[data-stc-i]', w), k = 0;
    var show = function (n) { k = (n + cs.length) % cs.length; cs.forEach(function (c, i) { c.hidden = i !== k; c.classList.toggle('iw-is-on', i === k); }); };
    var p = $('[data-stc-p]', w), n = $('[data-stc-n]', w);
    if (cs.length < 2) { if (p) p.parentNode.hidden = true; return; }
    p.addEventListener('click', function () { show(k - 1); }); n.addEventListener('click', function () { show(k + 1); });
  });
  /* ---------- Inner Wellness (Etappe 9): Kapsel öffnet sich leicht beim Scrollen; linke Hälfte wechselt ruhig durch die Inhaltsgruppen ---------- */
  $$('[data-inw]').forEach(function (v) {
    var ls = $$('[data-inw-l]', v), ts = $$('[data-inw-t]', v), ds = $$('[data-inw-d]', v), cap = $('.iw-inw-cap', v), k = 0, timer = null, vis = false, hold = 0;
    var show = function (n) {
      k = (n + ls.length) % ls.length;
      ls.forEach(function (x, i) { x.classList.toggle('iw-is-on', i === k); });
      ts.forEach(function (x, i) { x.classList.toggle('iw-is-on', i === k); });
      ds.forEach(function (x, i) { if (i === k) x.setAttribute('aria-current', 'true'); else x.removeAttribute('aria-current'); });
    };
    var tick = function () { if (Date.now() < hold) return; show(k + 1); };
    var run = function () { if (timer || !MO() || !vis || d.hidden) return; timer = setInterval(tick, 2800); };
    var stop = function () { clearInterval(timer); timer = null; };
    ds.forEach(function (b, i) { b.addEventListener('click', function () { show(i); hold = Date.now() + 6000; }); });
    if (MO() && cap) {
      var upd = function () { var r = cap.getBoundingClientRect(), vh = innerHeight || 800; var p = (vh * 0.95 - r.top) / (vh * 0.55); p = Math.max(0, Math.min(1, p)); v.style.setProperty('--p', p.toFixed(3)); };
      onScroll(function () { raf(upd); }); window.addEventListener('resize', function () { raf(upd); }); upd();
    }
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) { es.forEach(function (e) { vis = e.isIntersecting; if (vis) run(); else stop(); }); }, { threshold: 0.35 }).observe(v);
    }
    d.addEventListener('visibilitychange', function () { if (d.hidden) stop(); else run(); });
  });
  /* ---------- Rezeptur auf einen Blick (Etappe 8.5): Kapsel öffnet sich mit dem Scrollen, Gruppen antippbar ---------- */
  $$('[data-gl]').forEach(function (gl) {
    var cap = $('.iw-gl-cap-w', gl), gs = $$('[data-gl-g]', gl);
    if (cap && MO()) {
      var upd = function () { var r = cap.getBoundingClientRect(), vh = innerHeight || 800; var p = (vh * 0.92 - r.top) / (vh * 0.5); p = Math.max(0, Math.min(1, p)); gl.style.setProperty('--p', p.toFixed(3)); };
      onScroll(function () { raf(upd); }); window.addEventListener('resize', function () { raf(upd); }); upd();
    }
    var set = function (g) {
      var k = g ? g.getAttribute('data-gl-g') : null;
      if (k) gl.setAttribute('data-act', k); else gl.removeAttribute('data-act');
      gs.forEach(function (x) { x.classList.toggle('iw-act', x === g); x.setAttribute('aria-pressed', x === g ? 'true' : 'false'); });
    };
    gs.forEach(function (g) {
      g.setAttribute('tabindex', '0'); g.setAttribute('role', 'button'); g.setAttribute('aria-pressed', 'false');
      var tog = function () { set(g.classList.contains('iw-act') ? null : g); };
      g.addEventListener('click', tog);
      g.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); tog(); } });
      if (matchMedia('(hover: hover)').matches) { g.addEventListener('mouseenter', function () { set(g); }); g.addEventListener('mouseleave', function () { set(null); }); }
    });
  });
  $$('[data-gl-replay]').forEach(function (b) { b.addEventListener('click', function () {
    var gl = b.closest('.iw-x-glance'); gl = gl && gl.querySelector('.iw-gl'); if (!gl || !MO()) return;
    gl.classList.add('iw-gl-reset'); gl.classList.remove('iw-in'); void gl.offsetWidth;
    raf(function () { gl.classList.remove('iw-gl-reset'); raf(function () { gl.classList.add('iw-in'); }); });
  }); });
  /* ---------- Bewertungen: mobil zunächst nur die ersten Einträge, „Mehr Erfahrungen anzeigen“ klappt den Rest auf (ohne JS alle sichtbar) ---------- */
  $$('[data-rv-list]').forEach(function (ul) {
    var sec = ul.closest('.iw-x-reviews'), btn = sec && $('[data-rv-more]', sec);
    if (!btn || !$('.iw-rvi-more', ul)) return;
    sec.classList.add('iw-rv-collapsed'); btn.hidden = false;
    btn.addEventListener('click', function () {
      var open = sec.classList.toggle('iw-rv-collapsed') === false;
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      btn.textContent = open ? 'Weniger anzeigen' : 'Mehr Erfahrungen anzeigen';
      if (open) { var first = $('.iw-rvi-more', ul); if (first) { first.setAttribute('tabindex', '-1'); first.focus({ preventScroll: true }); } }
      else btn.scrollIntoView({ block: 'nearest', behavior: RM.matches ? 'auto' : 'smooth' });
    });
  });

  /* ---------- Widerruf / Kündigung: Zeitstempel, Eingangsbestätigung über Klaviyo (Etappe 14.7), Zusammenfassung zum Speichern ----------
     Ablauf: Event an Klaviyo (löst den Bestätigungs-Flow aus), danach normaler Versand an Shopify. Das Feld „Automatische Bestätigung“
     zeigt dem Team in der Shopify-Mail, ob die Bestätigung rausging – sonst muss sie von Hand verschickt werden. */
  var FX_METRIC = { widerruf: 'Widerruf eingegangen', kuendigung: 'Kündigung eingegangen' };
  $$('form[data-fx]').forEach(function (f) {
    var kind = f.getAttribute('data-fx'), key = (f.getAttribute('data-fx-kl') || '').trim(), sent = false;
    f.addEventListener('submit', function (e) {
      if (sent) return;   // zweiter Durchlauf nach dem Klaviyo-Event: normaler Shopify-Versand
      if (!f.checkValidity()) { e.preventDefault(); f.reportValidity && f.reportValidity(); return; }
      var now = new Date(), stamp = now.toLocaleString('de-DE', { dateStyle: 'long', timeStyle: 'medium', timeZone: 'Europe/Berlin' }) + ' (deutsche Zeit)';
      var t = $('[data-fx-time]', f); if (t) t.value = stamp;
      var lines = [], val = {};
      $$('.iw-fx', f).forEach(function (fx) {
        var l = $('label', fx), i = $('input, select, textarea', fx); if (!l || !i || !i.value) return;
        var v = i.type === 'date' ? i.value.split('-').reverse().join('.') : i.value.trim(); val[i.id] = v;
        lines.push(l.childNodes[0].textContent.trim() + ': ' + v);
      });
      try { sessionStorage.setItem('iw-fx-' + kind, [($('h1') || {}).textContent || kind, 'Zeitpunkt: ' + stamp].concat(lines).join('\n')); } catch (err) {}
      if (f.hasAttribute('data-proto-fx')) {   // Prototyp: nichts wird übermittelt
        e.preventDefault(); var ok = f.nextElementSibling; f.hidden = true; if (ok) { ok.hidden = false; $('[data-fx-copy]', ok).textContent = lines.join(' · '); }
        return;
      }
      var mail = $('input[type="email"]', f), st = $('[data-fx-kl-status]', f), b = $('button[type="submit"]', f);
      var mark = function (ok) {
        if (st) st.value = ok ? 'automatisch an ' + mail.value.trim() + ' versendet' : 'NICHT automatisch versendet – bitte von Hand bestätigen';
        try { sessionStorage.setItem('iw-fx-kl-' + kind, ok ? '1' : '0'); } catch (err) {}
      };
      if (!key || !mail || !window.fetch) { mark(false); return; }
      e.preventDefault(); sent = true;
      if (b) { b.disabled = true; b.setAttribute('aria-busy', 'true'); }
      var end = kind !== 'kuendigung' ? '' : (val['kf-when'] === 'Zu einem bestimmten Datum' && val['kf-date'] ? 'zum ' + val['kf-date'] : 'zum nächstmöglichen Zeitpunkt');
      var ac = window.AbortController ? new AbortController() : null, timer = setTimeout(function () { if (ac) ac.abort(); }, 6000);
      var done = function (ok) { clearTimeout(timer); mark(ok); if (b) { b.disabled = false; b.removeAttribute('aria-busy'); } if (f.requestSubmit) f.requestSubmit(); else f.submit(); };
      fetch('https://a.klaviyo.com/client/events?company_id=' + encodeURIComponent(key), {
        method: 'POST', keepalive: true, signal: ac ? ac.signal : undefined, headers: { 'Content-Type': 'application/vnd.api+json', revision: '2024-10-15' },
        body: JSON.stringify({ data: { type: 'event', attributes: {
          properties: { Typ: kind === 'widerruf' ? 'Widerruf' : 'Kündigung', Eingang: stamp, Name: val['wf-name'] || val['kf-name'] || '', Beendigung: end, Angaben: lines },
          metric: { data: { type: 'metric', attributes: { name: FX_METRIC[kind] } } },
          profile: { data: { type: 'profile', attributes: { email: mail.value.trim() } } },
          time: now.toISOString(), unique_id: kind + '-' + now.getTime() } } })
      }).then(function (r) { done(r.status === 202 || r.ok); }, function () { done(false); });
    });
  });
  $$('[data-fx-ok]').forEach(function (ok) {
    var form = ok.closest('form') || ok.previousElementSibling, kind = (ok.closest('[data-fx]') || form || {}).getAttribute ? (ok.closest('[data-fx]') || form).getAttribute('data-fx') : '';
    var txt = '', kl = null; try { txt = sessionStorage.getItem('iw-fx-' + kind) || ''; kl = sessionStorage.getItem('iw-fx-kl-' + kind); } catch (e) {}
    var c = $('[data-fx-copy]', ok); if (c && txt && !c.textContent) { c.style.whiteSpace = 'pre-line'; c.textContent = txt; }
    var m = $('[data-fx-kl-msg]', ok);
    if (m && kl !== null) m.textContent = kl === '1' ? 'Eine Eingangsbestätigung haben wir dir gerade per E-Mail geschickt. Schau bitte auch im Spam-Ordner nach.'
      : 'Die automatische Bestätigung per E-Mail hat leider nicht geklappt. Deine Erklärung ist trotzdem bei uns eingegangen, wir bestätigen sie dir zusätzlich per E-Mail. Speichere dir diese Seite am besten.';
    var b = $('[data-fx-print]', ok); if (b) b.addEventListener('click', function () { window.print(); });
  });

  /* ---------- Cookie-Einstellungen: nur anzeigen, wenn Shopifys Consent-Banner verfügbar ist (kein Ersatzdialog) ---------- */
  var consentTry = 0;
  (function consentInit() {
    var api = window.privacyBanner;
    if (api && typeof api.showPreferences === 'function') {
      $$('[data-consent-li]').forEach(function (li) { li.hidden = false; });
      $$('[data-consent-open]').forEach(function (b) { b.addEventListener('click', function () { api.showPreferences(); }); });
    } else if (consentTry++ < 20) setTimeout(consentInit, 500);
  })();
})();
